export default "__VITE_ASSET__Dz_rw7$W__"